export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-page-6dd7eef44aa2f2a80b84831ba74bfaf9.svg";